if (!customElements.get('partner-modal')) {
  class PartnerModal extends HTMLElement {
    constructor() {
      super();
      this.timeoutId;
      this.triggerUsed;
      this.closeModalBtn = this.querySelector('.close-modal');
      this.loader = document.querySelector('.loader');
      this.triggers = document.querySelectorAll(
        '[data-gold-partner-modal="trigger"]',
      );
    }

    connectedCallback() {
      if (window.location.href.indexOf('msPartnerStatus=show') > -1) {
        this.classList.add('show');
      }

      // Attach hover event to triggers
      this.triggers.forEach((trigger) => {
        const loader = trigger.querySelector('.loader');

        trigger.addEventListener('mouseenter', () => {

          this.showLoader(loader);
          if (!this.timeoutId) {
            this.timeoutId = window.setTimeout(() => {
              this.triggerUsed = trigger;
              this.timeoutId = null;
              this.hideLoader(loader);
              this.showModal();
            }, 1500);
          }
        });

        trigger.addEventListener('mouseleave', () => {
          if (this.timeoutId) {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = null;
            this.hideLoader(loader);
          } else {
            this.hideLoader(loader);
          }
        });
      });

      // Close modal when clicking close button
      if (this.closeModalBtn) {
        this.closeModalBtn.addEventListener('click', () => this.hideModal());
      }

      // Close modal when clicking outside of it
      this.addEventListener('click', (event) => {
        if (event.target === this) {
          this.hideModal();
        }
      });

      // Close modal with escape key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.hideModal();
        }
      });
    }

    // Function to show modal
    showModal() {
      this.classList.add('show');
      this.setAttribute('aria-hidden', 'false');
    }

    // Function to hide modal
    hideModal() {
      this.classList.remove('show');
      this.triggerUsed?.focus();
      this.setAttribute('aria-hidden', 'true');
    }

    // Function to show loader
    showLoader(loader) {
      if (!loader) {
        return;
      }

      loader.style.display = 'block';
    }

    // Function to hide loader
    hideLoader(loader) {
      if (!loader) {
        return;
      }

      loader.style.display = 'none';
    }
  }

  customElements.define('partner-modal', PartnerModal);
}
